import { CircularProgress } from '@mui/material';
import { styled } from '@mui/system';

import { useMemo } from 'react';

import { Link } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { Typography } from '@app-velocity/ui';

import { ReportPaths } from '../../../../paths/ReportPaths';

import { useReportContext } from '../../../../context/useReportContext';

const StyledNotification = styled(Link)(({ theme }) => ({
  borderRadius: theme.spacing(4),
  background: '#ffffff',
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  color: '#7a7a7a',
}));

export const SimulationNotification = () => {
  const { pendingSimulations, type, baseURL } = useReportContext();
  const { t } = useI18n();

  const title = useMemo(() => {
    if (!pendingSimulations || pendingSimulations.length === 0) return null;

    // only one at a time for Figma
    if (type === 'figma') {
      switch (pendingSimulations[0]) {
        case 'EXTENDED':
          return t('prototypes:extended_simulation_in_progress', {
            amount: 10,
          });
        case 'EXTENDED_3':
          return t('prototypes:extended_simulation_in_progress', { amount: 3 });
        case 'EXTENDED_50':
          return t('prototypes:extended_simulation_in_progress', {
            amount: 50,
          });
        case 'EXTENDED_100':
          return t('prototypes:extended_simulation_in_progress', {
            amount: 100,
          });
        case 'SINGLE':
          return t('prototypes:simulation_in_progress');
      }
    }

    if (type === 'vibe') {
      return t('prototypes:vibe_simulation_in_progress', {
        count: pendingSimulations.length,
      });
    }
  }, [pendingSimulations, t]);

  if (!pendingSimulations || pendingSimulations.length === 0) return null;

  return (
    <StyledNotification to={ReportPaths.goToConfidence(baseURL)}>
      <CircularProgress size={12} thickness={5} color="primary" />
      <Typography>{title}</Typography>
    </StyledNotification>
  );
};
